import lazyLoading from './lazyLoading'
import Apis from '../../../core/Apis'

export default {
    path: '/quality',
    component: lazyLoading('qualityManage', true),
    meta: {
        icon: 'fa fa-cog fa-fw menu-icon',
        label: '质量检查',
        expanded: false,
        noRedirect: true
    },
    children: [
        {
            name: 'QualityManage',
            path: 'index',
            component: lazyLoading('qualityManage/QualityManage'), // 加载模块
            meta: {
                label: '质量检查',
                hidden: true,
                auth: {
                    needApis: [Apis.bzxt.quality.qualityList]
                }
            }
        },
        {
            name: 'CrowdInspection',
            path: 'crowdInspection',
            component: lazyLoading('qualityManage/CrowdInspection'), // 加载模块
            meta: {
                label: '众包质检',
                hidden: true,
                auth: {
                    needApis: [Apis.bzxt.quality.qualityList]
                }
            }
        },
        {
            name: 'CrowdDetail',
            path: 'crowdDetail',
            component: lazyLoading('qualityManage/CrowdDetail'), // 加载模块
            meta: {
                label: '众包质检详情',
                parent: 'CrowdInspection',
                nomenu: true
            }
        },
        {
            name: 'CrowdAudit',
            path: 'crowdAudit',
            component: lazyLoading('qualityManage/CrowdAudit'), // 加载模块
            meta: {
                label: '众包质检详情',
                parent: 'CrowdInspection',
                nomenu: true
            }
        },
        {
            name: 'CrossFault',
            path: 'crossfault',
            component: lazyLoading('qualityManage/CrossFault'), // 加载模块
            meta: {
                label: '交叉错误数据列表',
                parent: 'QualityManage',
                nomenu: true
            }
        },
        {
            name: 'QualityFault',
            path: 'qualityfault',
            component: lazyLoading('qualityManage/QualityFault'), // 加载模块
            meta: {
                label: '质检错误数据列表',
                parent: 'QualityManage',
                nomenu: true
            }
        },
        {
            name: 'MissonList',
            path: 'missonlist',
            component: lazyLoading('qualityManage/TaskView'), // 加载模块
            meta: {
                label: '指定任务',
                parent: 'QualityManage',
                nomenu: true,
                api: [
                    // 权限验证
                    // Apis.qukan.config.list
                ]
            }
        },
        {
            name: 'QcTaskDetail',
            path: 'taskdetail',
            component: lazyLoading('qualityManage/TaskDetail'), // 加载模块
            meta: {
                label: '任务详情',
                parent: 'QualityManage',
                nomenu: true,
                api: [
                    // 权限验证
                    // Apis.qukan.config.list
                ]
            }
        },
        {
            // qc
            name: 'Inspecting',
            path: 'inspecting',
            component: lazyLoading('contentlabel/Inspecting'), // 加载模块
            meta: {
                label: '质检详情',
                parent: 'QualityManage',
                nomenu: true
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/qualityManage.js